import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, EMPTY, Observable, ReplaySubject, catchError, delay, observable, of, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RouteData } from 'src/app/models/route-data.model';
import { SigError, SigRequest, SigResult, SigSession, XodoResult } from 'src/app/models/sig-request.model';
import { SocketService } from './socket.service';

@Injectable({
  providedIn: 'root'
})
export class SignaturesService {
  private BASE_URL = environment.landmark_API_URL + '/signatures';
  private selectedSession = new BehaviorSubject<SigSession>(new SigSession());
  selectedSession$ = this.selectedSession.asObservable();
  
  private selectedURLSubject: ReplaySubject<string>;
  public selectedSignURL: Observable<string>;
  

  constructor(private http: HttpClient, private socketService: SocketService) {
    this.selectedURLSubject = new ReplaySubject<string>();
    this.selectedSignURL = this.selectedURLSubject.asObservable();
    // this.socketService.receiveRoute().subscribe((data:RouteData) => {
    //   console.log('Received notification data:', data);
    //   if(data.dataType === 'session'){
    //     this.getSession(data.data).subscribe((session: SigSession) => {
    //       this.setSelectedSession(session);
    //     });
    //   }
    // });
   }


   refreshSigSession(id: number, docHash: string): Observable<SigSession> {
    return this.http.get<SigSession>(`${this.BASE_URL}/refresh/${id}/${docHash}`).pipe(
      tap(data => {
        this.selectedSession.next(data);
      }),
      catchError(error => {
        console.error('Error:', error);
        return throwError(error);
      })
    );
  }

  getSessions(): Observable<any[]> {
    return this.http.get<any[]>(`${this.BASE_URL}`);
  }

  getSession(id: number): Observable<SigSession> {
    return this.http.get<SigSession>(`${this.BASE_URL}/sessions/${id}`);
  }

  getSelectedSession(): Observable<SigSession> {
    return this.selectedSession;
  }

  getSelectedSignURL(): Observable<string> {
    return this.selectedSignURL;
  }

  setSelectedSession(session:SigSession){
    this.selectedSession.next(session);
  };

  getHistory(hash: string): Observable<XodoResult> {
    console.log('getHistory called with:', hash);
    return this.http.get<XodoResult>(`${this.BASE_URL}/history/${hash}`);
  }

  sendReminder(hash: string,signerId: number): Observable<any> {
    return this.http.post(`${this.BASE_URL}/reminder/`, {
      docHash: hash,
      signerId: signerId
    });
  }

  cancelSignatureRequest(hash: string, binderId: number): Observable<any> {
    return this.http.post(`${this.BASE_URL}/cancel/`, {
      docHash: hash,
      binderId: binderId,
      isDrafting: false
    });
  }

  cancelDraftingRequest(hash: string, binderId: number, message: string, user: string): Observable<any> {
    return this.http.post(`${this.BASE_URL}/cancel/`, {
      docHash: hash,
      binderId: binderId,
      message: message,
      user: user,
      isDrafting: true
    });
  }

  setSelectedURL(url:string): Observable<string> {
    console.log('setSelectedURL called with:', url);
    this.selectedURLSubject.next(url);
    return this.selectedURLSubject.asObservable();
  };

  updateNote(noteId: number, changes: Partial<SigSession>): Observable<any> {
    return this.http.put(`${this.BASE_URL}/notes/${noteId}`, changes);
  }

  deleteNote(noteId: number) {
    return this.http.delete(`${this.BASE_URL}/notes/${noteId}`);
  }

  requestSignatures(request:SigRequest): Observable<SigResult> {
    return this.http.post<SigResult>(`${this.BASE_URL}/request`,request);
  }
}
